import { useState, useEffect } from 'react';
import * as authService from '../services/authService';

interface UseAuthReturn {
  role: string;
  userId: number | null;
  email: string;
  assignedDomains: string[];
  loading: boolean;
  error: Error | null;
}

export function useAuth(): UseAuthReturn {
  const [role, setRole] = useState<string>('');
  const [userId, setUserId] = useState<number | null>(null);
  const [email, setEmail] = useState<string>('');
  const [assignedDomains, setAssignedDomains] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');

    if (!token) {
      setLoading(false);
      return;
    }

    const validateUserToken = async () => {
      try {
        const data = await authService.validateToken();
        setRole(data.role);
        setUserId(data.userId);
        setEmail(data.email);
        setAssignedDomains(data.assignedDomains || []);
      } catch (err) {
        console.error('Token validation error:', err);
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    validateUserToken();
  }, []);

  return { role, userId, email, assignedDomains, loading, error };
}
